const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/app/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    enableMock: false
}

export default appConfig